import { EmailTemplateBox } from './EmailTemplateBox';
import { Box, Heading, SimpleGrid } from '@chakra-ui/react';

export const EmailPageTemplates = (props: {
  textTemplateIds: string[];
}) => {

  const groups = props.textTemplateIds.reduce((acc, id) => {
    const groupTitle = id.replace(/^V2_/, '').split('_')[0];
    const group = acc.find(g => g.groupTitle === groupTitle);
    if (group) {
      group.templateIds.push(id);
    } else {
      acc.push({ groupTitle, templateIds: [id] });
    }
    return acc;
  }, [] as { groupTitle: string, templateIds: string[] }[]);

  return (
    groups.map(group => (
      <Box key={group.groupTitle}>
        <Heading size='xs' mt={8} mb={4}>{group.groupTitle}</Heading>
        <SimpleGrid columns={2} spacing={6}>
          {group.templateIds.map(templateId => (<EmailTemplateBox key={templateId} templateId={templateId} />))}
        </SimpleGrid>
      </Box>
    ))

  );
}